import { resolvePositioningCollisions } from '../ui/positioningCollision';

export type CollisionNode = {
	uid: string;
	x: number;
	y: number;
	width: number;
	height: number;
	fixed?: boolean;
};

export const separateCollidingNodes = (
	nodes: CollisionNode[],
	{ padding = 16, iterations = 16 }: { padding?: number; iterations?: number } = {}
): CollisionNode[] => {
	const rects = nodes.map((node) => ({
		key: node.uid,
		x: node.x - node.width / 2,
		y: node.y - node.height / 2,
		width: node.width,
		height: node.height,
		movable: !node.fixed,
	}));
	const anchoredKey = nodes.find((node) => node.fixed)?.uid;
	const resolved = resolvePositioningCollisions(rects, { anchoredKey, padding, iterations });
	const byUid = new Map(nodes.map((node) => [node.uid, node]));
	return resolved.map((rect) => {
		const previous = byUid.get(rect.key);
		return {
			uid: rect.key,
			x: rect.x + rect.width / 2,
			y: rect.y + rect.height / 2,
			width: rect.width,
			height: rect.height,
			fixed: previous?.fixed,
		};
	});
};
